import React, { MouseEvent, StatelessComponent } from 'react';
import cls from '../utils/classnames';
import { FOCUSABLE, FOCUSABLE_ROUNDED } from '../utils/classes';
import './_styles.scss';

export interface IFocusableProps {
    /**
     * id to add to element
     */
    id?: string;
    /**
     * class name to add to element
     * */
    className?: string;
    /**
     * handle on click of element
     */
    onClick?: (event: MouseEvent<{}>) => unknown;
    /**
     * flag to add a rounded border to focus
     */
    rounded?: boolean;

    blockedRight?: object;
}

/**
 * This component is to emulate a focusable area in order to Spatial Navigation recognize as a focusable element
 */
export const Focusable: StatelessComponent<IFocusableProps> = props => {
    const { id, className, onClick, rounded = false, children, blockedRight } = props;
    const classNames = cls(FOCUSABLE, className, {
        [FOCUSABLE_ROUNDED]: rounded
    });

    return (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url
        <a id={id} className={classNames} onClick={onClick} href="javascript:void(0)"  {...blockedRight}>
            {children}
        </a>
    );
};



// WEBPACK FOOTER //
// ./src/packages/components/lib/Focusable/index.tsx